import React from 'react';

function StopsPagination({ currentPage, totalPages, setCurrentPage }) {
  const goToPreviousPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };

  return (
    <nav className="pagination" aria-label="Nawigacja stron">
      <button
        onClick={goToPreviousPage}
        disabled={currentPage === 1}
        className="pagination-button"
        aria-label="Poprzednia strona"
      >
        <i className="fas fa-chevron-left" aria-hidden="true"></i>
        <span>Poprzednia</span>
      </button>

      <span className="pagination-info" aria-live="polite">
        Strona {currentPage} z {totalPages}
      </span>

      <button
        onClick={goToNextPage}
        disabled={currentPage === totalPages}
        className="pagination-button"
        aria-label="Następna strona"
      >
        <span>Następna</span>
        <i className="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </nav>
  );
}

export default StopsPagination;